export const dop_legislation = [
  {
    id: 1,
    name: 'Public Service Act Regulations amendments as gazzeted on the 20 Oct 2023',
    summary: 'shortsummary/Public Service Act Regulations amendments as gazzeted on the 20 Oct 2023.html',
    link: 'Public Service Act Regulations amendments as gazzeted on the 20 Oct 2023.pdf',
    audio_en: 'audio/en/Public Service Act Regulations amendments as gazzeted on the 20 Oct 2023_en.mp3',
    audio_af: 'audio/af/Public Service Act Regulations amendments as gazzeted on the 20 Oct 2023_af.mp3',
    audio_xh: 'audio/xh/Public Service Act Regulations amendments as gazzeted on the 20 Oct 2023_xh.mp3'
  }
];